var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4703_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 20.0013L25.3334 4.0013H30.6667L30.6667 20.0013H25.3334ZM20 4.0013C20.7073 4.0013 21.3855 4.28226 21.8856 4.78235C22.3857 5.28245 22.6667 5.96073 22.6667 6.66797L22.6667 20.0013C22.6667 20.7346 22.3734 21.4013 21.88 21.8813L13.1067 30.668L11.6934 29.2546C11.3334 28.8946 11.1067 28.4013 11.1067 27.8546L11.1467 27.428L12.4134 21.3346L4.00002 21.3346C3.29278 21.3346 2.6145 21.0537 2.1144 20.5536C1.6143 20.0535 1.33335 19.3752 1.33335 18.668L1.33335 16.0013C1.33335 15.6546 1.40002 15.3346 1.52002 15.028L5.54669 5.62797C5.94669 4.66797 6.89335 4.0013 8.00002 4.0013L20 4.0013ZM20 6.66797L7.96002 6.66797L4.00002 16.0013L4.00002 18.668L15.72 18.668L14.2134 25.7613L20 19.9613L20 6.66797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33335 18.668C1.33335 19.3752 1.6143 20.0535 2.1144 20.5536C2.6145 21.0537 3.29278 21.3346 4.00002 21.3346L12.4267 21.3346L11.1467 27.428C11.12 27.5613 11.1067 27.708 11.1067 27.8546C11.1067 28.4013 11.3334 28.908 11.6934 29.268L13.1067 30.668L21.88 21.8946C22.3734 21.4013 22.6667 20.7346 22.6667 20.0013L22.6667 6.66797C22.6667 5.96073 22.3857 5.28245 21.8856 4.78235C21.3855 4.28226 20.7073 4.0013 20 4.0013L8.00002 4.0013C6.89335 4.0013 5.94669 4.66797 5.54669 5.62797L1.52002 15.028C1.40002 15.3346 1.33335 15.6546 1.33335 16.0013L1.33335 18.668ZM30.6667 4.0013H25.3334L25.3334 20.0013H30.6667L30.6667 4.0013Z",
    fill: "#008BFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4703_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 -1 32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDislike);
export default __webpack_public_path__ + "static/media/FilledDislike.fdce4c1dca3a53e11c5e100ad45b6ebc.svg";
export { ForwardRef as ReactComponent };